import { render } from "./ComponentPanel.vue?vue&type=template&id=88bd1ce8&scoped=true"
import script from "./ComponentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentPanel.vue?vue&type=script&setup=true&lang=js"

import "./ComponentPanel.vue?vue&type=style&index=0&id=88bd1ce8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bd1ce8"],['__file',"src/pages/scada/ComponentPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88bd1ce8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88bd1ce8', __exports__)) {
    console.log('reload')
    api.reload('88bd1ce8', __exports__)
  }
  
  module.hot.accept("./ComponentPanel.vue?vue&type=template&id=88bd1ce8&scoped=true", () => {
    console.log('re-render')
    api.rerender('88bd1ce8', render)
  })

}


export default __exports__